'use client'

import { HeartCrack } from 'lucide-react'

import { useFlow } from '@/shared/lib/steps-flow'
import { Button } from '@/shared/ui/Button'

import { HUD } from './HUD'

export const StepLivesOver = () => {
  const { reset } = useFlow()

  const handleRestart = reset

  return (
    <HUD.Root>
      <HUD.Card>
        <HUD.Header>Sem vidas</HUD.Header>
        <HUD.Body className="row-span-2">
          <div className="flex flex-col items-center justify-center p-6 rounded-2xl bg-jacaranda/20 min-h-[250px]">
            <HeartCrack className="text-danger w-12 h-12 mb-4" />
            <span className="text-xl font-bold mb-2 text-center text-red-700">
              É uma pena, mas suas vidas acabaram!
            </span>
            <span className="text-gray-800 text-center text-md mb-8">
              Tente novamente para conquistar este nível.
            </span>
          </div>
        </HUD.Body>
        <HUD.Footer>
          <Button variant="primary" onClick={handleRestart} className="flex-1">
            Tentar mais uma vez
          </Button>
        </HUD.Footer>
      </HUD.Card>
    </HUD.Root>
  )
}
